export const ROLES = {
  ADMIN: 'administrateur',
  COMMERCIAL: 'commercial',
  CLIENT: 'client',
  CANDIDAT: 'candidat',
} as const

export type UserRole = (typeof ROLES)[keyof typeof ROLES]
